// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29Cxk","newExpiryDate":"styles_newExpiryDate__3MnxM","footer":"styles_footer__1xx4E"};